import debounce from './debounce'
import renameKey from './renameKey'
import toc from './toc'
import constants from './constants'
import info from './salesContactInfo'
import isFunction from './isFunction'
import isObject from './isObject'
import validateEmail from './validateEmail'
import parseFraction from './parseFraction'
import getStyle from './getStyle'
import copyToClipboard from './copyToClipboard'

export default {
  debounce,
  renameKey,
  toc,
  constants,
  info,
  isFunction,
  isObject,
  validateEmail,
  parseFraction,
  getStyle,
  copyToClipboard
}
